import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

const misc: any = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    sidebar_mini_active: true
};

export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    isCollapsed?: boolean;
    isCollapsing?: any;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    type?: string;
    collapse?: string;
    children?: ChildrenItems2[];
    isCollapsed?: boolean;
}
export interface ChildrenItems2 {
    path?: string;
    title?: string;
    type?: string;
}
// Menu Items
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ROUTES: RouteInfo[] = [
    // {
    //     path: '/admin',
    //     title: 'Dashboard',
    //     type: 'link',
    //     icontype: 'ni-button-play text-primary'
    // },
    // {
    //     path: '/admin/rss-registrations',
    //     title: 'Join Rss Registrations',
    //     type: 'link',
    //     icontype: 'ni-shop text-primary'
    // },
    // {
    //     path: '/admin/student-registrations',
    //     title: 'Student Registrations',
    //     type: 'link',
    //     icontype: 'ni-badge text-primary'
    // },
    // {
    //     path: '/admin/department',
    //     title: 'Departments',
    //     type: 'sub',
    //     icontype: 'ni-ungroup text-orange',
    //     collapse: 'examples',
    //     isCollapsed: true,
    //     children: [
    //         { path: 'view', title: 'View', type: 'link' },
    //         { path: 'create', title: 'Create', type: 'link' }
    //     ]
    // },
    // {
    //     path: '/admin/team',
    //     title: 'Teams',
    //     type: 'sub',
    //     icontype: 'ni-ui-04 text-info',
    //     collapse: 'components',
    //     isCollapsed: true,
    //     children: [
    //         { path: 'view', title: 'View', type: 'link' },
    //         { path: 'create', title: 'Create', type: 'link' }
    //     ]
    // },
    {
        path: '/event',
        title: 'Events',
        type: 'sub',
        icontype: 'ni-single-copy-04 text-pink',
        collapse: 'forms',
        isCollapsed: true,
        children: [
            { path: 'view', title: 'View', type: 'link' },
            { path: 'create', title: 'Create', type: 'link' }
        ]
    },
    // {
    //     path: '/admin/gallery',
    //     title: 'Gallery',
    //     type: 'sub',
    //     icontype: 'ni-align-left-2 text-default',
    //     collapse: 'tables',
    //     isCollapsed: true,
    //     children: [
    //         { path: 'view', title: 'View', type: 'link' },
    //         { path: 'create', title: 'Create', type: 'link' }
    //     ]
    // },
    // {
    //     path: '/admin/announcement',
    //     title: 'Announcements',
    //     type: 'sub',
    //     icontype: 'ni-map-big text-primary',
    //     collapse: 'maps',
    //     isCollapsed: true,
    //     children: [
    //         { path: 'view', title: 'View', type: 'link' },
    //         { path: 'create', title: 'Create', type: 'link' }
    //     ]
    // }
];
@Component({
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    styleUrls: ['./admin-sidebar.component.css']
})
export class AdminSidebarComponent implements OnInit {
    public menuItems: any[];
    public isCollapsed = false;
    constructor(private router: Router) {}

    ngOnInit(): void {
        this.menuItems = ROUTES.filter((menuItem) => menuItem);
        this.router.events.subscribe((event) => {
            this.isCollapsed = false;
        });
        this.minimizeSidebar();
    }
    onMouseEnterSidenav(): void {
        if (!document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.add('g-sidenav-show');
        }
    }
    onMouseLeaveSidenav(): void {
        if (!document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-show');
        }
    }
    minimizeSidebar(): void {
        const sidenavToggler = document.getElementsByClassName('sidenav-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        misc.sidebar_mini_active = body.classList.contains('g-sidenav-pinned');
        if (misc.sidebar_mini_active === true) {
            body.classList.remove('g-sidenav-pinned');
            body.classList.add('g-sidenav-hidden');
            sidenavToggler.classList.remove('active');
            misc.sidebar_mini_active = false;
        } else {
            body.classList.add('g-sidenav-pinned');
            body.classList.remove('g-sidenav-hidden');
            sidenavToggler.classList.add('active');
            misc.sidebar_mini_active = true;
        }
    }
}
